import { InstitucionService } from './../../services/institucion/institucion.service';
import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { tap } from 'rxjs/operators';
import { StaffActions } from './staff.actions';

export class StaffStateModel {
  public estado!: boolean;
  public mensaje!: string;
  public profesionales!: Profesional[];
}
export class Profesional {
  public slug!: string;
  public nombre!: string;
  public apellido!: string;
  public imagen_perfil!: string;
  public profesion!: string;
  public especialidades!: Especialidades[];
}
export class Especialidades {
  especialidad_uid!: string;
  especialidad!: string;
  matricula!: string;
}
const defaults = {
  estado: false,
  mensaje: 'Ocurrió un error, intenta nuevamente.',
  profesionales: [],
};

@State<StaffStateModel>({
  name: 'staff',
  defaults,
})
@Injectable()
export class StaffState {

  constructor(
    private institucionSerivce: InstitucionService,
  ) { }

  @Action(StaffActions.LoadStaff)
  LoadStaff({ dispatch }: StateContext<StaffStateModel>,
    { slug, especialidad_uid }: StaffActions.LoadStaff) {
    return this.institucionSerivce.getInstitucionStaff(slug, especialidad_uid).pipe(
      tap(
        (result) => {
          dispatch(new StaffActions.SetStaff(result.estado,
            result.mensaje,
            result.institucion.profesionales));
        },
        (err) => { }
      )
    );
  }

  @Action(StaffActions.SetStaff)
  SetStaff({ getState, setState }: StateContext<StaffStateModel>,
    { estado, mensaje, profesionales }: StaffActions.SetStaff) {
    const state = getState();
    setState(
      {
        ...state,
        estado: estado,
        mensaje: mensaje,
        profesionales: profesionales,
      });
  }
}
